var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-result',{staticClass:"submit-success",attrs:{"icon":"success","title":"提交成功","subTitle":"我们已经收到您的申请，审核通过后我们将通过电话联系您"}},[_c('template',{slot:"extra"},[_c('el-button',{attrs:{"size":"default","type":"primary"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_vm._v("返回")])],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }